<template>
  <section>
    <v-footer app class="pt-3">
      <v-btn x-large @click.prevent="regresar" class="mr-5"
        ><v-icon>chevron_left</v-icon> Regresar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" x-large @click.prevent="descargar"
        ><v-icon>file_download</v-icon> Descargar
      </v-btn>
    </v-footer>
    <v-form @submit.prevent="obtenerReporte">
      <v-layout row>
        <v-flex
          xs12
          class="text-h4 mb-3 primary--text font-weight-medium text-uppercase"
        >
          {{ catalogoReporte.NombreReporte }}
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 md2 v-for="filtro in catFiltros" :key="filtro.Filtro">
          <v-text-field
            outlined
            v-if="filtro.CatalogoTipoID === 1"
            v-model="filtros[filtro.Parametro]"
            :label="filtro.Label || filtro.Filtro"
          >
          </v-text-field>
          <date-picker
            outlined
            v-model="filtros[filtro.Parametro]"
            :label="filtro.Label || filtro.Filtro"
            v-if="filtro.CatalogoTipoID === 2"
          >
          </date-picker>
          <v-autocomplete
            outlined
            clearable
            :items="catalogos[filtro.Parametro]"
            item-text="Label"
            item-value="Value"
            v-model="filtros[filtro.Parametro]"
            :label="filtro.Label || filtro.Filtro"
            v-if="filtro.CatalogoTipoID === 3"
          >
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 md1>
          <v-btn fab type="submit" color="primary" dark
            ><v-icon dark color="white">search</v-icon></v-btn
          >
        </v-flex>
      </v-layout>
    </v-form>
    <v-card class="mt-3">
      <v-card-text>
        <v-data-table :items="registros" :items-per-page="50">
          <template slot="header">
            <tr class="mb-6">
              <th
                class="primary--text text-left pa-2"
                v-for="columna in columnas"
                :key="columna"
              >
                {{ columna }}
              </th>
            </tr>
          </template>
          <template slot="item" slot-scope="scope">
            <tr>
              <td v-for="columna in columnas" :key="columna">
                {{ scope.item[columna] }}
              </td>
            </tr>
          </template>
          <template slot="no-data">
            No hay datos para mostrar
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import ServicioReportes from '../../services/reportes';
import exportFromJSON from 'export-from-json';
import DatePicker from '../../components/DatePicker.vue';
export default {
  name: 'reporteDinamico',
  props: ['catalogoReporte'],
  components: {DatePicker},
  data() {
    return {
      filtros: {},
      catFiltros: [],
      columnas: [],
      registros: [],
      catalogos: {},
    };
  },
  methods: {
    descargar() {
      const fileName = 'Reporte_' + this.fechaPicker(new Date());
      const exportType = exportFromJSON.types.xls;

      exportFromJSON({data: this.registros, fileName, exportType});
    },
    regresar() {
      this.$emit('cerrar');
    },
    async obtenerFiltros() {
      const res = await ServicioReportes.obtenerFiltrosReporte(
        this.catalogoReporte.CatalogoReporteID
      );
      if (res.data.result === 1) {
        const filtros = res.data.data.Table0;
        // Fecha
        filtros
          .filter((f) => f.CatalogoTipoID === 2)
          .forEach((f) => {
            if (!isNaN(f.ValorDefault)) {
              const fecha = new Date();
              fecha.setDate(fecha.getDate() + parseInt(f.ValorDefault));
              this.filtros[f.Parametro] = this.fechaPicker(fecha);
            }
          });

        // Catalogos
        let i = 1;
        filtros
          .filter((f) => f.CatalogoTipoID === 3)
          .forEach((f) => {
            this.catalogos[f.Parametro] = res.data.data['Table' + i];
          });
        this.catFiltros = filtros;
        await this.obtenerReporte();
      } else {
        this.$root.mensajeError(res.data.message);
      }
    },
    async obtenerReporte() {
      const {SP, Metodo} = this.catalogoReporte;
      const res = await ServicioReportes.obtenerReporte(
        SP,
        Metodo,
        this.filtros
      );
      if (res.data.result === 1) {
        if (res.data.data.Table0.length) {
          this.columnas = Object.keys(res.data.data.Table0[0]);
          this.registros = res.data.data.Table0;
        } else {
          this.columnas = [];
          this.registros = [];
        }
      } else {
        this.$root.mensajeError = res.data.message;
      }
    },
  },
  mounted() {
    this.obtenerFiltros();
  },
};
</script>

<style></style>
